export enum LoginOption {
  MemoQ = 0,
  SSO = 1,
  Both = 2
}
